

































































import {Component, Prop, Vue} from "vue-property-decorator";
import InputPageWrapper from "@/views/components/input/InputPageWrapper.vue";

import {designStore} from "@/store/store";
import {UnitSystem} from "@/interfaces/units";
import {calculateAcOverlay} from "@/modules/design/lib/calculations/acOverlayCalculation";
import GenericPavementDiagram from "@/modules/design/views/components/GenericPavementDiagram.vue";
import {ILayerDef} from "@/modules/design/interfaces/shared";
import {createAcOverlayValidations} from "@/modules/design/lib/validations/acOverlay";
import {IAcOverlayDesignImperial, IAcOverlayDesignMetric} from "@/modules/design/interfaces/acOverlay";
import ValidatedInputPageWrapper from "@/views/components/input/ValidatedInputPageWrapper.vue";
import {imperialPrecision, metricPrecision} from "@/main";
import ScenarioInformationReport from "@/modules/design/views/components/report/ScenarioInformationReport.vue";
import DesignParametersReport from "@/modules/design/views/components/report/DesignParametersReport.vue";
import LayersReport from "@/modules/design/views/components/report/LayersReport.vue";
// import {AsphaltStructureReport,LayersReport} from "@/modules/design/views/components/report/LayersReport.vue";
// import LayersReport from "@/modules/design/views/components/report/LayersReport.vue";


@Component({
  components: {
    LayersReport,
    // AsphaltStructureReport,
    DesignParametersReport,
    ScenarioInformationReport, ValidatedInputPageWrapper, GenericPavementDiagram, InputPageWrapper
  },
})
export default class AcOverlayReport extends Vue {
  @Prop() readonly page!: number;

  get scenario(): IAcOverlayDesignImperial | IAcOverlayDesignMetric {
    return designStore.currentAcOverlay;
  }

  get scenarioImperial() {
    return designStore.currentAcOverlayImperial;
  }

  validations() {
    return createAcOverlayValidations(this.scenarioImperial);
  }

  get results() {
    return calculateAcOverlay(designStore.currentAcOverlayImperial);
  }

  get resultPrecision() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? imperialPrecision : metricPrecision;
  }

  get depthToRemove() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return this.scenario.removeDepth_in;
    }
    return this.scenario.removeDepth_cm;
  }

  get thicknessUnit() {
    return designStore.displayUnits === UnitSystem.Imperial
        ? "in"
        : "cm";
  }

  get thicknessMultiplier() {
    return designStore.displayUnits === UnitSystem.Imperial
        ? 1
        : 2.54;
  }

  get numLayers() {
    // Required for validating whether the user has created any layers.
    return this.scenarioImperial.existingLayers.length;
  }

  get layers(): ILayerDef[] {
    const layers = this.results.layers.map((L: any) => ({
      name: L.label,
      thickness: L.depth,
      unit: this.thicknessUnit,
      type: L.type,
    })).filter((L: any) => L.thickness > 0);

    layers.push({
      name: "Subgrade",
      type: "subgrade",
      thickness: null,
      unit: this.thicknessUnit,
    });


    return layers;
  }

  save() {
    designStore.saveCurrentAcOverlayScenario();
  }

  print() {
    window.print();
  }
}

